
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./messaging_extension": () => {
return Promise.all([__webpack_require__.e("2957"), __webpack_require__.e("7544"), __webpack_require__.e("2795"), __webpack_require__.e("8337"), __webpack_require__.e("8466")]).then(() => (() => (__webpack_require__(2073))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };